module.exports = __webpack_public_path__ + "static/media/11.479ff521.jpg";